export enum MsgTypeDownloadEnum {
    ERROR = 'ERROR',
    SUCCESS = 'SUCCESS'
  }
